//imports
import {
    IMPORT_ACCOUNT_NEW_MIGRATION_OPEN_MODAL,
    IMPORT_ACCOUNT_SEARCH_ACCOUNTS_REQUEST,
    IMPORT_ACCOUNT_SEARCH_ACCOUNTS_RESULT,
    IMPORT_ACCOUNT_GET_ACCOUNT_REQUEST,
    IMPORT_ACCOUNT_GET_ACCOUNT_RESULT,
    IMPORT_ACCOUNT_IMPORT_REQUEST,
    IMPORT_ACCOUNT_IMPORT_RESULT,
    IMPORT_ACCOUNT_GET_STATUS_REQUEST,
    IMPORT_ACCOUNT_GET_STATUS_RESULT,
    IMPORT_ACCOUNT_GET_ACCOUNT_BY_PX_REQUEST,
    IMPORT_ACCOUNT_GET_ACCOUNT_BY_PX_RESULT,
    IMPORT_ACCOUNT_GET_MIGRATION_ACCOUNT_REQUEST,
    IMPORT_ACCOUNT_GET_MIGRATION_ACCOUNT_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    accountsList: [],
    account: null,
    loading: false,
    result: null,
    status: null,
    pxAccount: null,
    migrationAccount: null,
    internalMigratedAccount: null,
    legacyAccountCodes: null
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case IMPORT_ACCOUNT_NEW_MIGRATION_OPEN_MODAL:
            return { ...state, openModal: action.payload }

        case IMPORT_ACCOUNT_SEARCH_ACCOUNTS_REQUEST:
            return { ...state, loading: true }

        case IMPORT_ACCOUNT_SEARCH_ACCOUNTS_RESULT:
            return { ...state, loading: false, accountsList: action.payload }

        case IMPORT_ACCOUNT_GET_ACCOUNT_REQUEST:
            return { ...state, loading: true }

        case IMPORT_ACCOUNT_GET_ACCOUNT_RESULT:
            return { ...state, loading: false, account: action.payload }

        case IMPORT_ACCOUNT_IMPORT_REQUEST:
            return { ...state, loading: true }

        case IMPORT_ACCOUNT_IMPORT_RESULT:
            return { ...state, loading: false, result: action.payload }

        case IMPORT_ACCOUNT_GET_STATUS_REQUEST:
            return { ...state, loading: true }

        case IMPORT_ACCOUNT_GET_STATUS_RESULT:
            return { ...state, loading: false, status: action.payload }

        case IMPORT_ACCOUNT_GET_ACCOUNT_BY_PX_REQUEST:
            return { ...state, loading: true }

        case IMPORT_ACCOUNT_GET_ACCOUNT_BY_PX_RESULT:
            return { ...state, loading: false, pxAccount: action.payload }

        case IMPORT_ACCOUNT_GET_MIGRATION_ACCOUNT_REQUEST:
            return { ...state, loading: true }

        case IMPORT_ACCOUNT_GET_MIGRATION_ACCOUNT_RESULT:
            return { ...state, loading: false, migrationAccount: action.payload.migrationAccount, internalMigratedAccount: action.payload.internalMigratedAccount, legacyAccountCodes: action.payload.legacyAccountCodes }

        case CLEAR_REDUX:
            return ["", "IMPORT_ACCOUNT"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};